import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fcfba34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setting" }
const _hoisted_2 = { class: "setting-section" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "ユーザー管理", -1))
const _hoisted_4 = { class: "setting-section" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "調査牛一覧取り込み", -1))
const _hoisted_6 = { class: "setting-section" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "飼養管理者と農家ユーザーの紐付け", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserImpersonation = _resolveComponent("UserImpersonation")!
  const _component_CattleImport = _resolveComponent("CattleImport")!
  const _component_BreedingManagerAdmin = _resolveComponent("BreedingManagerAdmin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_UserImpersonation)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_CattleImport)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode(_component_BreedingManagerAdmin)
    ])
  ]))
}